// extracted by mini-css-extract-plugin
export default {"layoutBody":"Layout_layoutBody__AQcMX","layoutSide":"Layout_layoutSide__Qex8J","layoutContent":"Layout_layoutContent__4XRGI"};